import React from 'react';
// import TodoApp from './TodoApp';
import TodoApp from './components/TodoApp';

function App() {
    return (
        <div className="App">
            <TodoApp />
        </div>
    );
}

export default App;
